/**
 * GATSBY_CUSTOMER_API_URL includes the v1 prefix (…/Prod/v1).
 * Strip it so each call can name its own version. Otherwise /v2 routes
 * are requested as /v1/v2/…, which API Gateway does not expose.
 */
export const customerApiBaseUrl = (configuredUrl: string): string => {
  if (!configuredUrl) {
    return configuredUrl;
  }

  return configuredUrl.replace(/\/v1\/?$/, '');
};
